<p-dialog header="{{ currentPatentInventor.person?.id ? ('common.editOf'|hisUi:('fs.res.patent.Patent.inventors.percentages'|hisUi)) : ('fs.res.patent.assignExternalPerson'|hisUi) }}" 
    [(visible)]="visibility" [modal]="true" height="auto" (onHide)="closeDialog()" [draggable]="false" [blockScroll]="true">

    <div class="layoutBlock">
        <div class="columnFullWidth">
            
            <ng-container *ngIf="!currentPatentInventor.person?.id"> 
                <!-- Person -->
                <res-external-person-create [(externalPerson)]="currentPatentInventor.person"></res-external-person-create>
                <his-plam class="noPlamStyle">
                <!-- Externe Organisation -->
                <res-organizations-panel #content
                    hisDdKey="fs.res.patent.PatentInventor.organization"
                    [ngModel]="{ externalOrganizations: this.externalOrganizations }"
                    [newResearchPartner]="researchPartner"
                    [editMode]="true"
                    [singleSelect]="true"
                    [isCreateInline]="true"
                    [isAddOrganization]="isAddOrganization"
                    [showCreateLink]="true"
                    [ddKey]="'fs.res.patent.PatentInventor.organization'"
                    header="fs.res.common.organizations.external"
                    (externalOrganizationsChange)="organizationsChange($event)"
                    (deleteExternalOrganizationChange)="deleteExternalOrganizationChange()">
                </res-organizations-panel></his-plam>
            </ng-container>
            
            <!-- Percentage for inventor -->
            <res-patent-edit-inventor-percentage
                [patentInventor]="currentPatentInventor">
            </res-patent-edit-inventor-percentage>
            
        </div>
    </div>

    <p-footer>
        <button (click)="savePatentInventor()" (keydown.tab)="$event.preventDefault(); $event.stopPropagation(); cancelBtn.focus();">
            <span>{{ 'common.apply' | hisUi }}</span>
        </button>
        <button #cancelBtn (click)="closeDialog()" (keydown.tab)="$event.stopPropagation();">
            <span>{{ 'common.cancel' | hisUi }}</span>
        </button>
     </p-footer>
</p-dialog>
